<!-- @format -->

<template>
  <flickity ref="flickity" :options="flickityOptions">
    <div v-for="cite in $config.cites" :key="cite.text" class="carousel-cell">
      <cite class="base-cite" :class="$mq">
        <p class="base-cite__text" v-text="cite.text" :class="$mq" />
        <p class="base-cite__author" v-text="cite.author" :class="$mq" />
      </cite>
    </div>
  </flickity>
</template>

<script>
import Flickity from 'vue-flickity'
require('flickity-fade')

export default {
  components: {
    Flickity,
  },
  props: {
    kinostart: {
      type: String,
      default: 'Releaseline',
    },
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 1,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 4500,
        fade: true,
        draggable: false,
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.flickity.resize()
    })
  },
}
</script>

<style lang="scss" scoped>
.carousel-cell {
  width: 100% !important;
  margin: 0 auto;
}
.base-cite {
  $self: &;
  width: 100% !important;
  &__text {
    font-family: 'Heebo', sans-serif;
    font-style: normal;
    font-weight: 500;
    color: white;
    line-height: 1.5;
    margin-bottom: 15px;
    text-align: center;
    margin: 0 auto;
    width: 50% !important;
    font-size: 1.6rem;
    &.lg {
      width: 60% !important;
    }
    &.xl {
      width: 50% !important;
    }
    &.xxl {
      width: 70% !important;
    }
    &.md {
      margin: 0;
      font-size: 35px;
      width: 100% !important;
    }
    &.sm {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 25px;
      width: 100% !important;
    }
  }
  &__author {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: #d52d2d;
    margin-top: 5px;
    font-size: 14px;
    &.sm {
      font-size: 0.7rem;
    }
    &.md {
      font-size: 0.9rem;
    }
  }
}
</style>
